// Layout params

export const LAYOUT_TYPE = 'layout-type';
export const LAYOUT_TYPE_PATH = `style.numbers.${LAYOUT_TYPE}`;

export const CARD_SIZE = 'layout-cardSize';
export const CARD_SIZE_PATH = `style.numbers.${CARD_SIZE}`;

export const CATEGORY_TEXT_ALIGNMENT = 'layout-tagTextAlignment';
export const CATEGORY_TEXT_ALIGNMENT_PATH = `style.numbers.${CATEGORY_TEXT_ALIGNMENT}`;

export const IS_HEADER_ENABLED = 'layout-isHeaderEnabled';
export const IS_HEADER_ENABLED_PATH = `style.booleans.${IS_HEADER_ENABLED}`;

// Post design params

export const APP_TEXT_COLOR = 'post-textColor';
export const APP_TEXT_COLOR_PATH = `style.colors.${APP_TEXT_COLOR}`;

export const BORDER_WIDTH_SMALL = 'post-borderWidthSmall';
export const BORDER_WIDTH_SMALL_PATH = `style.numbers.${BORDER_WIDTH_SMALL}`;

export const BORDER_WIDTH_MEDIUM = 'post-borderWidthMedium';
export const BORDER_WIDTH_MEDIUM_PATH = `style.numbers.${BORDER_WIDTH_MEDIUM}`;

export const BORDER_WIDTH_LARGE = 'post-borderWidthLarge';
export const BORDER_WIDTH_LARGE_PATH = `style.numbers.${BORDER_WIDTH_LARGE}`;

export const BORDER_WIDTH_CLASSIC = 'post-borderWidthClassic';
export const BORDER_WIDTH_CLASSIC_PATH = `style.numbers.${BORDER_WIDTH_CLASSIC}`;

export const CARD_BACKGROUND_COLOR = 'post-cardBackgroundColor';
export const CARD_BACKGROUND_COLOR_PATH = `style.colors.${CARD_BACKGROUND_COLOR}`;

export const APP_BACKGROUND_COLOR = 'post-appBackgroundColor';
export const APP_BACKGROUND_COLOR_PATH = `style.colors.${APP_BACKGROUND_COLOR}`;

// Button design params

export const BUTTON_COLOR = 'button-color';
export const BUTTON_COLOR_PATH = `style.colors.${BUTTON_COLOR}`;

export const SECONDARY_ICON_COLOR = 'icon-secondaryColor';
export const SECONDARY_ICON_COLOR_PATH = `style.colors.${SECONDARY_ICON_COLOR}`;

// Widget params

export const WIDGET_SIGN_UP_BUTTON_TYPE = 'widget-signUpButtonType';
export const WIDGET_SIGN_UP_BUTTON_TYPE_PATH = `style.numbers.${WIDGET_SIGN_UP_BUTTON_TYPE}`;

export const WIDGET_SIGN_UP_BUTTON_BORDER_COLOR = 'widget-signUpButtonBorderColor';
export const WIDGET_SIGN_UP_BUTTON_BORDER_COLOR_PATH = `style.colors.${WIDGET_SIGN_UP_BUTTON_BORDER_COLOR}`;

export const WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR = 'widget-signUpButtonBackgroundColor';
export const WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR_PATH = `style.colors.${WIDGET_SIGN_UP_BUTTON_BACKGROUND_COLOR}`;

export const WIDGET_SIGN_UP_BUTTON_FONT = 'widget-signUpButtonFont';
export const WIDGET_SIGN_UP_BUTTON_FONT_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_FONT}`;

export const WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR = 'widget-signUpButtonPrimaryColor';
export const WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_PRIMARY_COLOR}`;

export const WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR = 'widget-signUpButtonSecondaryColor';
export const WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR_PATH = `style.fonts.${WIDGET_SIGN_UP_BUTTON_SECONDARY_COLOR}`;

export const WIDGET_NOTIFICATION_ICON_COLOR = 'widget-notificationIconColor';
export const WIDGET_NOTIFICATION_ICON_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_ICON_COLOR}`;

export const WIDGET_NOTIFICATION_BUBBLE_COLOR = 'widget-notificationBubbleColor';
export const WIDGET_NOTIFICATION_BUBBLE_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_BUBBLE_COLOR}`;

export const WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR = 'widget-notificationBubbleTextColor';
export const WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR_PATH = `style.colors.${WIDGET_NOTIFICATION_BUBBLE_TEXT_COLOR}`;

export const WIDGET_AVATAR_BORDER_COLOR = 'widget-avatarBorderColor';
export const WIDGET_AVATAR_BORDER_COLOR_PATH = `style.colors.${WIDGET_AVATAR_BORDER_COLOR}`;

// Forum widget params

export const IS_LOGIN_WIDGET_ENABLED = 'widget-isLoginButtonEnabled';
export const IS_LOGIN_WIDGET_ENABLED_PATH = `style.booleans.${IS_LOGIN_WIDGET_ENABLED}`;



// WEBPACK FOOTER //
// ./app/constants/wix-params.js